<avano-panel
  [noPadding]="true"
  [avanoLoadingIndicator]="blockingIdentifier"
  [headerIcon]="'icon-special-declare-product'"
  [headerText]="translationKeys.productDeclarationComponent.html.header.productDeclarationLabel | translate"
>
  <p-treeTable
    [value]="bom"
    [selectionMode]="'single'"
    [(selection)]="selectedNode"
    (onNodeSelect)="nodeSelect($event)"
    (onNodeExpand)="lazyLoadNode($event)"
    [scrollable]="true"
    [autoLayout]="true"
    [lazy]="true"
    [scrollHeight]="'calc(100vh - 490px)'"
    [styleClass]="'bom-treetable'"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 49%">{{ translationKeys.productDeclarationComponent.html.nameColumnHeader | translate }}</th>
        <th style="width: 24%">{{ translationKeys.productDeclarationComponent.html.numberColumnHeader | translate }}</th>
        <th style="width: 19%">{{ translationKeys.productDeclarationComponent.html.infoColumnHeader | translate }}</th>
        <th style="width: 8%">{{ translationKeys.productDeclarationComponent.html.countColumnHeader | translate }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode">
        <td style="width: 47%">
          <div class="bom-type-entry-row">
            <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
            <i *ngIf="rowData['productType'] === productType.ARTICLE" class="icon-special-article"></i>
            <i *ngIf="rowData['productType'] === productType.HOMOGENEOUS_MATERIAL" class="icon-special-homogeneousmaterial"></i>
            <i *ngIf="rowData['productType'] === productType.MATERIAL" class="icon-special-homogeneousmaterial"></i>
            <i *ngIf="rowData['productType'] === productType.MIXTURE" class="icon-special-mixture"></i>
            <i *ngIf="rowData['productType'] === productType.SEMICOMPONENT" class="icon-special-semicomponent"></i>
            <i *ngIf="rowData['productType'] === productType.COMPONENT" class="icon-special-semicomponent"></i>
            <i *ngIf="rowData['productType'] === productType.SUBSTANCE" class="icon-special-substance"></i>
            <div avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
              {{ rowData['name'] }}
            </div>
          </div>
        </td>
        <td style="width: 23%">
          <div class="bom-type-entry-row">
            <div avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
              {{ rowData['primaryArticleIdentifierValue'] }}
            </div>
          </div>
        </td>
        <td style="width: 18%">
          <div class="bom-type-entry-row bom-type-entry-row-info">
            <ng-container *ngIf="rowData['isSVHC']">
              <div avanoEllipsis *ngIf="rowData['isSVHC'] === echaSvhcRelevance.Yes">
                <i class="icon-content-warning"></i>
                {{ translationKeys.productDeclarationComponent.html.isSVHCRelevant | translate }}
              </div>
              <div avanoEllipsis *ngIf="rowData['isSVHC'] === echaSvhcRelevance.NotAnyLonger">
                <i class="icon-content-success"></i>
                {{ translationKeys.productDeclarationComponent.html.noLongerRelevant | translate }}
              </div>
            </ng-container>

            <ng-container *ngIf="rowData['isOwn']">
              <div avanoEllipsis class="info-grid">
                <div class="referenced-dossier-own">
                  <i class="icon-content-referenced-dossier-own"></i>
                  {{ translationKeys.productDeclarationComponent.html.isReferenceOwn | translate }}
                </div>
                <div class="dossier-status"
                  *ngIf="rowData['dossierStatus']"
                  [title]="rowData['dossierStatus'] | dossierStateTranslationKey: true | translate"
                  
                  [setTitle]="false"
                >
                  <i class="icon-content-referenced-dossier"></i>
                  {{ rowData['dossierStatus'] | dossierStateTranslationKey | translate }}
                </div>
                <div class="dossier-error"
                  *ngIf="rowData['echaResponseStatus'] !== submissionStatus.DOSSIER_SENT_TO_ECHA && rowData['echaResponseStatus']"
                >
                  <i class="icon-content-error dossier-error-dialog-icon"
                    (click)="showErrorDetails(rowData['echaResponseStatus'], rowData['echaResponseErrorText'])"
                  >
                  </i>
                </div>
              </div>
            </ng-container>

            <div avanoEllipsis *ngIf="rowData['isDummy']">
              <i class="icon-content-automation"></i>
              {{ translationKeys.productDeclarationComponent.html.isDummy | translate }}
            </div>
          </div>
        </td>
        <td style="width: 10%">
          <div class="bom-type-entry-row bom-type-entry-row-count" *ngIf="rowData['count'] && rowData['count'] !== '0'">
            <div avanoEllipsis>{{ rowData['count'] }}</div>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="4">
          <div *ngIf="rootNodeWasEmpty" class="empty-root-node-msg">
            <i class="icon-content-warning"></i>
            {{ translationKeys.productDeclarationComponent.html.emptyRootNode | translate }}
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">
      <i class="icon-special-article"></i>
      {{ translationKeys.productDeclarationComponent.html.articleLabel | translate }}
      <i class="icon-special-homogeneousmaterial"></i>
      {{ translationKeys.productDeclarationComponent.html.homogeneousMaterialLabel | translate }}
      <i class="icon-special-mixture"></i>
      {{ translationKeys.productDeclarationComponent.html.mixtureLabel | translate }}
      <i class="icon-special-semicomponent"></i>
      {{ translationKeys.productDeclarationComponent.html.semicomponentOrComponentLabel | translate }}
      <i class="icon-special-substance"></i>
      {{ translationKeys.productDeclarationComponent.html.substanceLabel | translate }}
    </ng-template>
  </p-treeTable>
</avano-panel>

<scip-dossier-error-details-dialog
  *ngIf="showDossierErrorDetails"
  [dossierError]="selectedDossierError"
  (closeDialog)="showDossierErrorDetails = false"
></scip-dossier-error-details-dialog>
